export default __webpack_public_path__ + "static/genopets-2-c-1408cb8e6f40ee9a340158d5fe9221b3.webp";